/**
 * @fileoverview JkdownloadFileComponent 是一個 Angular 元件，用於提供檔案下載功能。
 * @description 這個元件繼承自 JkBaseComponent，並提供一個按鈕，點擊後可以下載指定 URL 的檔案。
 */
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { saveAs } from 'file-saver';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { MaterialModule } from '../../material.module';


@Component({
    selector: 'app-jkdownload',
    template: `
    <button mat-flat-button color="accent" (click)="downloadFile()" [matTooltip]="fileName">下載</button>
  `,
    styleUrls: ['./jkdownload.component.scss'],
    imports: [MaterialModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class JkdownloadFileComponent extends JkBaseComponent implements OnInit {
  /**
   * @override
   * @description 元件類型，固定為 'jkdownload'。
   */
  override comType: string = 'jkdownload';
  /**
   * @input
   * @description 要下載的檔案的 URL。
   */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  url!: string;
  /**
   * @input
   * @description 下載後檔案的名稱。
   */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  fileName!: string;
  /**
   * @input
   * @description 可選。指定接受的檔案類型。預設為 '*' (所有類型)。
   */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() accept: string = '*';
  /**
   * @constructor
   * @description JkdownloadFileComponent 的建構函式。
   */
  constructor(
  ) {
    super();
  }

  /**
   * @override
   * @description Angular 生命週期鉤子，元件初始化時調用。
   */
  override ngOnInit() {
    super.ngOnInit();
  }
  /**
   * @method
   * @description 初始化下載元件的參數。
   * @param url 要下載的檔案的 URL。
   * @param file 下載後檔案的名稱。
   * @param accept 可選。指定接受的檔案類型。預設為 '*'。
   */
  init(url: string, file: string,accept:string='*') {
    this.accept = accept;
    this.url = url;
    this.fileName = file;
  }
  /**
   * @method
   * @description 執行檔案下載操作。
   * @returns {Promise<void>}
   */
  async downloadFile() {
    if(!this.url){
      alert('網址空白!');
      return;
    }
    saveAs(this.url, this.fileName);
    /*
    let headers =  new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8',
      'Accept': this.accept // 'application/pdf'
    });
    // 設定請求選項，特別是 responseType 為 'blob'
    const options = {
      //headers: headers,
      //responseType: 'blob' as 'json' // 強制轉型為 'json'
      responseType: 'blob' as 'blob' // 強制轉型為 'json'
    };
    let g = this.http.get(this.url,{ responseType: 'json' }); // 'blob'
      g.subscribe((data: any) => {
        saveAs(data, this.fileName);
      }, error => {
        alert(error.message);
      });
        */
    /*.pipe(
      catchError(error => {
        //console.error('Error:', error);
        alert(error.message);
        //return ;
        return throwError(error);
      }))*/
  }
}
